import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import { IconArrowLink } from '../../1-foundation/icons/icons';
import { modifierList as iconsModifiersList } from '../../1-foundation/icons/props-list';

import { modifierList } from './props-list';

const DEFAULT_MODIFIERS = [];

const BannerMarketing = ({ tag = 'aside', imgSrc, text, modifiers = DEFAULT_MODIFIERS, showArrowIcon, onClick, iconsColor, ...tagAttributes }) => {
  const classNames = getClassNames('c-banner-marketing', modifiers);
  const Tag = tag;

  return (
    <Fragment>
      <Tag className={classNames} onClick={onClick} {...tagAttributes}>
        {imgSrc && (
          <div className="c-banner-marketing__wrap-image">
            <img crossOrigin="anonymous" className="c-banner-marketing__img" alt={text} src={imgSrc} />
          </div>
        )}
        <p className="c-banner-marketing__text">{text}</p>
        {showArrowIcon && <IconArrowLink modifiers={[iconsColor, 'arrow-navigation', 'arrow-link', 'small']} />}
      </Tag>
    </Fragment>
  );
};

BannerMarketing.propTypes = {
  tag: PropTypes.string,
  imgSrc: PropTypes.string,
  text: PropTypes.string.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  showArrowIcon: PropTypes.bool,
  onClick: PropTypes.func,
  iconsColor: PropTypes.oneOf(iconsModifiersList).isRequired,
};

export default BannerMarketing;
